<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="6" class="mx-auto" style="position:relative; top: -60px">

                <v-col cols="12" class="elevation-2 red lighten-2 text-white mb-4" v-if="institutional_proof && !institutional_proof.validated">
                    <h2 class="white--text">¡Espera!</h2>
                    <h3 class="white--text">Aún está pendiente de revisión tu comprobante institucional, por lo general esto tarda unos minutos. Es necesario esperar para recibir la bonificación correspondiente. Cuando esté listo, se te notificará vía correo electrónico.</h3>
                </v-col>

                <v-card class="mb-4" v-if="institutional_proof !== null && institutional_proof.validated && institutional_proof.institute.total_allowed > 0">
                    <v-card-title>Mis referidos institucionales</v-card-title>
                    <v-card-text>
                        <p class="text-center">Al formar parte de una institución registrada, podrás seleccionar hasta {{ institutional_proof.institute.total_allowed }} persona(s) que recibirá(n) la misma promoción.</p>
                        <v-simple-table v-if="institutionals.length > 0">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Usuario</th>
                                        <th>Correo electrónico</th>
                                        <th>Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(institutional, index) in institutionals" :key="index">
                                        <td>{{ institutional.referred.name }}</td>
                                        <td>{{ institutional.referred.email }}</td>
                                        <td>{{ institutional.date_applied }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text block color="#000" v-if="institutionals.length < institutional_proof.institute.total_allowed" @click="new_referred_dialog = !new_referred_dialog">Añadir referido</v-btn>
                    </v-card-actions>
                </v-card>

                <v-card>
                    <v-card-title>Mis referidos promocionales</v-card-title>
                    <v-card-text>
                        <h3 class="text-center">¡Refiere a todos tus amigos y obten ${{ user.country_code == 'MX' ? '100 pesos' : '6 dolares' }} de descuento en tu próximo pago!*</h3>
                        <v-simple-table class="my-4" v-if="promotionals.length > 0">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Usuario</th>
                                        <th>Correo electrónico</th>
                                        <th>Desc. Aplicado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(promotional, index) in promotionals" :key="index">
                                        <td>{{ promotional.referred.name }}</td>
                                        <td>{{ promotional.referred.email }}</td>
                                        <td>{{ promotional.date_applied ? promotional.date_applied : 'Pendiente' }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn outlined class="mb-5" block color="#000" @click="referred_link">copiar enlace</v-btn>
                                <small><i>*La promoción se aplicará cuando el referido realice su primer pago de inscripción y mensualidad.</i></small>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>


        <v-dialog v-model="new_referred_dialog" max-width="800" persistent>
            <v-card>
                <v-card-title>Nuevo referido institucional</v-card-title>
                <v-card-text>
                    <v-form ref="search" v-on:submit.prevent="search">
                        <v-text-field v-model="email" filled color="#000" clearable label="Ingresa el correo electrónico del usuario" :rules="[rules.required, rules.email]" append-outer-icon="mdi-magnify" @click:append-outer="search"></v-text-field>
                    </v-form>
                    <div class="text-center">
                        <v-skeleton-loader
                        class="mx-auto"
                        v-if="loading"
                        type="list-item-avatar"
                        ></v-skeleton-loader>

                        <v-list v-if="selected_user != '' && !loading" class="elevation-1">
                            <v-list-item>
                                <v-list-item-avatar size="80">
                                    <v-img :src="icon_url+selected_user.name+'.svg'"></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>{{ selected_user.names+" "+selected_user.paternal_surname+" "+selected_user.maternal_surname }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ selected_user.email }}</v-list-item-subtitle>
                                  </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="new_referred_dialog = false" :disabled="loading || add_loading">cancelar</v-btn>
                    <v-btn color="primary" :disabled="!selected_user != ''" @click="add" :loading="add_loading">Añadir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['user','promotionals','institutional_proof','institutionals','referred_url'],
    data: () => ({
        new_referred_dialog:false,
        icon_url:"https://avatars.dicebear.com/api/initials/",
        email:"",
        add_loading:false,
        _institutionals:[],
        loading:false,
        selected_user:"",
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido'
        },
    }),

    created(){
        this._institutionals = this.institutionals;
    },

    methods:{
        referred_link: function(){
            this.loading_referred = true
            const textarea = document.createElement('textarea');
            textarea.value = this.referred_url;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);

            iziToast.success({
                title:"Correcto",
                message:"Enlace copiado correctamente",
                position:"topRight"
            })

            this.loading_referred = false
        },

        search:function(){
            if(this.$refs.search.validate()){
                this.loading = true
                axios.get("/my-referrals/search", { params: { email:this.email } }).then(response => {
                    this.loading = false
                    this.selected_user = response.data.user
                }).catch(error => {
                    this.loading = false
                    this.selected_user = ""
                })
            }
        },

        add:function(){
            this.add_loading = true
            axios.post("/my-referrals/institutional/add", { user_id : this.selected_user.id }).then(response => {

                this._institutionals = response.data.institutionals

                iziToast.success({
                    title:"Correcto",
                    message:"Promoción aplicada correctamente",
                    position:"topRight"
                })
            }).catch(error => {

                iziToast.error({
                    title:"Error",
                    message: error.response.data.error,
                    position:"topRight"
                })
            })

            this.$refs.search.reset()
            this.email = this.selected_user = ""
            this.new_referred_dialog = this.add_loading = false
        }
    }
}
</script>
